import FocusableBackButton from '@components/FocusableBackButton';
import FocusableIconButton from '@components/FocusableIconButton';
import { useTreatmentHistoryDetailContext } from '@context/TreatmentHistoryDetail';
import { FocusContext } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';

import {
  TREATMENT_HISTORY_DEETAIL_BACK_BUTTON,
  TREATMENT_HISTORY_DETAIL_PRESCRIPTION_BUTTON,
  TREATMENT_HISTORY_DETAIL_RETRY_PAYMENT_BUTTON,
  TREATMENT_HISTORY_DETAIL_TREATMENT_PAYMENT_BUTTON,
  TREATMENT_HISTORY_DETAIL_VIEW
} from '../focusKey';
import DeliveryStatus from './components/DeliveryStatus';
import PharmacyStatus from './components/PharmacyStatus';
import TreatmentStatus from './components/TreatmentStatus';

import * as styles from './styles';

const TreatmentHistoryDetailView = () => {
  const {
    treatment,
    prescriptionState,
    isPharmacyStatusVisible,
    isDeliveryStatusVisible,
    isRetryPayment,
    goTreatmentPayment,
    goPrescription,
    goRetryPayment,
    setButtonFocus
  } = useTreatmentHistoryDetailContext();

  useEffect(() => {
    setButtonFocus();
  }, [setButtonFocus]);

  const prescriptionView = () => {
    if (prescriptionState === undefined) {
      return undefined;
    }

    if (prescriptionState === 'notYet') {
      return <div css={styles.description}>아직 처방전이 발행되지 않았습니다</div>;
    }

    if (prescriptionState === 'nonePrescription') {
      return <div css={styles.description}>처방전 없는 진료입니다</div>;
    }

    if (prescriptionState === 'notEstimatePayment') {
      return <div css={styles.description}>진료비 산정 전 입니다</div>;
    }

    if (prescriptionState === 'needPayment') {
      return (
        <FocusableIconButton
          focusKey={TREATMENT_HISTORY_DETAIL_TREATMENT_PAYMENT_BUTTON}
          onEnterPress={goTreatmentPayment}
          iconType="check"
        >
          진료비 결제
        </FocusableIconButton>
      );
    }

    return (
      <FocusableIconButton
        focusKey={TREATMENT_HISTORY_DETAIL_PRESCRIPTION_BUTTON}
        onEnterPress={goPrescription}
        iconType="arrow"
      >
        처방전
      </FocusableIconButton>
    );
  };

  return (
    <FocusContext.Provider value={TREATMENT_HISTORY_DETAIL_VIEW}>
      <div css={styles.rootContainer}>
        <div css={styles.mainContainer}>
          <div css={styles.mainTopContainer}>
            <FocusableBackButton focusKey={TREATMENT_HISTORY_DEETAIL_BACK_BUTTON} />
          </div>
          <div css={styles.mainContentContainer}>
            <div css={styles.mainContentTopContainer}>
              <div css={styles.name}>{treatment?.doctor?.name}</div>
            </div>
            <div css={styles.mainContentCenterContainer}>
              {<TreatmentStatus />}
              {isPharmacyStatusVisible && <PharmacyStatus />}
              {isDeliveryStatusVisible && <DeliveryStatus />}
            </div>
          </div>
        </div>
        <div css={styles.rightContainer}>
          {treatment && prescriptionView()}
          {isRetryPayment && (
            <FocusableIconButton
              focusKey={TREATMENT_HISTORY_DETAIL_RETRY_PAYMENT_BUTTON}
              onEnterPress={goRetryPayment}
              iconType="check"
            >
              전체 재결제
            </FocusableIconButton>
          )}
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default TreatmentHistoryDetailView;
